module.exports = __webpack_public_path__ + "img/donante-trepsi.566cec8c.jpeg";